import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { enableAkitaProdMode } from "@datorama/akita";
import * as Sentry from "@sentry/angular";
import LogRocket from "logrocket";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

Sentry.init({
    ...environment.sentry,
    integrations: [
        Sentry.replayIntegration({ blockAllMedia: false, maskAllInputs: false, maskAllText: false }),
        Sentry.browserTracingIntegration({ shouldCreateSpanForRequest: (url) => url === environment.apiUrl })
    ]
});

if (environment.logrocket.enabled) {
    LogRocket.init(environment.logrocket.appId, {
        network: {
            requestSanitizer(request) {
                if (request.url.endsWith("session") || !request.url.includes(environment.apiUrl)) {
                    return null;
                }

                request.headers["cookie"] = null;
                return request;
            },
            responseSanitizer(response) {
                response.headers["cookie"] = null;
                return response;
            }
        }
    });
}

if (environment.production) {
    enableProdMode();
    enableAkitaProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch(err => console.error(err));
